/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { useDispatch, useSelector } from 'react-redux';
import { getBillingProfilesRequest } from 'redux-api/action/billing';
import selectProfile from 'redux-api/reselect/profile';
import BillingProfiles from './billing-profiles';
import PaymentAccounts from './payment-accounts';
import TaxInterviews from './tax-interviews';

const Wrapper = styled.div`
  ${space}

  display: flex;
  align-items: center;
  flex-direction: column;

  & > div {
    width: 100%;
    max-width: 2100px;
  }
`;

function Profiles() {
  const dispatch = useDispatch();

  const {
    payload: { company },
  } = useSelector(selectProfile);

  useEffect(() => {
    dispatch(getBillingProfilesRequest());
  }, [dispatch]);

  return (
    <Wrapper px="l" py="xs" my="xs">
      <div>
        <BillingProfiles />

        <PaymentAccounts edit={false} company={company?.code} />

        {!!company && company.code === 'SL_US' && <TaxInterviews />}
      </div>
    </Wrapper>
  );
}

export default Profiles;
